"use strict";

var ONE_DAY_MS = 24 * 60 * 60 * 1000;
var KEY_PREFIX = 'xp-lib-brand:alert-banner:';
var isDismissed = function isDismissed(id) {
  if (!id) return false;
  var raw;
  try {
    raw = localStorage.getItem(KEY_PREFIX + id);
  } catch (e) {
    return false;
  }
  if (!raw) return false;
  var expires = parseInt(raw, 10);
  if (Number.isNaN(expires)) {
    try {
      localStorage.removeItem(KEY_PREFIX + id);
    } catch (e) {}
    return false;
  }
  if (Date.now() > expires) {
    try {
      localStorage.removeItem(KEY_PREFIX + id);
    } catch (e) {}
    return false;
  }
  return true;
};
document.querySelectorAll('.o-alert-banner').forEach(function (banner) {
  var id = banner.dataset.alertBannerId;
  if (!id) {
    banner.hidden = false;
    return;
  }
  if (!isDismissed(id)) banner.hidden = false;
  var closeBtn = banner.querySelector('.o-alert-banner__close');
  if (!closeBtn) return;
  closeBtn.addEventListener('click', function () {
    try {
      localStorage.setItem(KEY_PREFIX + id, String(Date.now() + ONE_DAY_MS));
    } catch (e) {}
    banner.hidden = true;
  });
});